import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  isOverTop: boolean
  isOverBottom: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  drag: {
    marginRight: '6px',
    cursor: 'grab'
  },

  forceHover: {
    backgroundColor: '#f7f8f9'
  },

  emptyDrag: {
    width: '16px',
    marginRight: '6px'
  },

  drop: {
    height: '0.25rem !important'
  },

  dropTop: {
    background: ({ isOverTop }) =>
      isOverTop ? theme.palette.primary.main : 'transparent'
  },

  dropBottom: {
    background: ({ isOverBottom }) =>
      isOverBottom ? theme.palette.primary.main : 'transparent'
  }
}))

export default useStyles
